module.exports = __webpack_public_path__ + "img/icon_lb.9f58b337.svg";